import React from 'react';

export function SectionTitle({ index, children }) {
  return (
    <div className="mb-6 flex min-w-0 items-start sm:mb-10 sm:items-center">
      <h2 className="m-0 min-w-0 whitespace-normal break-words font-mono text-[1.6rem] font-bold leading-[1.2] text-[#e8effd] sm:text-[2.125rem]">
        <span className="mr-4 text-[0.7em] text-[#00f3ff] [text-shadow:0_0_10px_rgba(0,243,255,0.5)]">
          {String(index).padStart(2, '0')}.
        </span>
        {children}
      </h2>
      <div className="ml-4 mt-4 h-px min-w-[32px] flex-grow bg-[linear-gradient(90deg,rgba(0,243,255,0.52),rgba(255,149,0,0.24),transparent)] sm:ml-6 sm:mt-0" />
    </div>
  );
}
